import { createStore, getActionIds } from '../../helpers/redux';
import Immutable from 'immutable';

import { RenameProjectPropertyActions } from '../../actions/forms/renameProjectProperty';
import { ProjectActions } from '../../actions/project';

const projectActions = getActionIds(ProjectActions);
const renameProjectPropertyActions = getActionIds(RenameProjectPropertyActions);

const initialState = Immutable.fromJS({
  form: {},
  currentProjectId: null,
  currentProp: null,
  submitting: false,
  notifications: {},
});

export const renameProjectPropForm = createStore(initialState, {
  [projectActions.resetReducers]: (state, action) => {
    return initialState;
  },

  [projectActions.renameProjectProperty.failure]: (state, action) => {
    return state.merge({
      notifications: {
        error: [
          {
            message: action.error[Object.keys(action.error)[0]][0],
          },
        ],
      },
    });
  },

  [renameProjectPropertyActions.setActiveProperty]: (state, action) => {
    return state.merge({
      form: { projectPropName: action.prop.prop },
      currentProjectId: action.prop.currentProjectId,
      currentProp: action.prop.prop,
    });
  },

  [renameProjectPropertyActions.updateFormOnChange]: (state, action) => {
    return state.merge({
      form: action.form,
    });
  },

  [renameProjectPropertyActions.dismissNotices]: (state, action) => {
    return state.merge({
      notifications: {},
    });
  },
});



// WEBPACK FOOTER //
// ./src/reducers/forms/renameProjectProperty.js